import { BaseService } from './base-service';

class CalendarService extends BaseService {
  /********************************
   * 工作日程-->日历看板
   ********************************/
  /**
   *  工作日程--外呼妙记--权限分配
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.videoUrl
   * @returns
   * @memberof LeadsService
   */
  addPersonVideoUrl(data) {
    return this.request({
      method: 'post',
      url: `/outCall/addPersonVideoUrl`,
      data
    });
  }
  /**
   *  工作日程--会议妙记--权限分配
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.videoUrl
   * @returns
   * @memberof LeadsService
   */
  addMettingVideoUrl(data) {
    return this.request({
      method: 'post',
      url: `/calender/addMettingVideoUrl`,
      data
    });
  }
  /**
   *  线索详情--动态记录妙记--权限分配
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.videoUrl
   * @returns
   * @memberof LeadsService
   */
  addFollowVideoUrl(data) {
    return this.request({
      method: 'post',
      url: `/calender/addFollowVideoUrl`,
      data
    });
  }
  /**
   *  工作日程--日历看板--获取日程列表
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.gmtCreated
   * @returns
   * @memberof LeadsService
   */
  getCalenderDetail(data) {
    return this.request({
      method: 'post',
      url: `/calender/getCalenderDetail`,
      data
    });
  }
  /**
   *  工作日程--日历看板--中间大日历--日程数据统计接口
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.gmtCreated
   * @returns
   * @memberof LeadsService
   */
  getCalenderCount(data) {
    return this.request({
      method: 'post',
      url: `/calender/getCalenderCount`,
      data
    });
  }
  /**
   *  工作日程--日历看板--右侧tab页签通话记录--获取通话记录列表
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.gmtCreated
   * @returns
   * @memberof LeadsService
   */
  getCalendarCallDetail(data) {
    return this.request({
      method: 'post',
      url: `/outCall/getCalendarCallDetail`,
      data
    });
  }
  /**
   *  工作日程--日历看板--申请入会
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @param  {integer} params.calendarRecordId
   * @returns
   * @memberof LeadsService
   */
  joinTheMetting(params) {
    return this.request({
      method: 'get',
      url: `/calender/joinTheMetting`,
      params
    });
  }

  /********************************
   * 工作日程-->添加日程
   ********************************/

  /**
   *  工作日程--添加日程，
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @param  {integer} params.calendarRecordId
   * @returns
   * @memberof LeadsService
   */
  getCompanyList(params) {
    return this.request({
      method: 'get',
      url: `/calender/name_data_list`,
      params
    });
  }
  /**
   *  日程--完成日程，
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @param  {integer} params
   * @returns
   * @memberof LeadsService
   */
  done(params) {
    return this.request({
      method: 'get',
      url: `/dynamic/record/task/done`,
      params
    });
  }

  /********************************
   * 工作日程-->日程列表
   ********************************/
  /**
   *  工作日程--日程列表--日程明细--日程视角
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.startTime
   * @returns
   * @memberof LeadsService
   */
  scheduleList(data) {
    return this.request({
      method: 'post',
      url: `/workSchedule/scheduleList`,
      data
    });
  }
  /**
   *  工作日程--日程列表--日程明细--人员视角
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.startTime
   * @returns
   * @memberof LeadsService
   */
  personList(data) {
    return this.request({
      method: 'post',
      url: `/workSchedule/personList`,
      data
    });
  }
  /**
   *  工作日程--日程列表--日程明细--人员视角--查看详情
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.startTime
   * @returns
   * @memberof LeadsService
   */
  personDetail(data) {
    return this.request({
      method: 'post',
      url: `/workSchedule/personDetail`,
      data
    });
  }
  /**
   *  工作日程--日程列表--数据概览
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.startTime
   * @returns
   * @memberof LeadsService
   */
  dataOverviewLeft(data) {
    return this.request({
      method: 'post',
      url: `/workSchedule/dataOverviewLeft`,
      data
    });
  }
  /**
   *  工作日程--日程列表--跟进方式
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.startTime
   * @returns
   * @memberof LeadsService
   */
  dataOverviewRight(data) {
    return this.request({
      method: 'post',
      url: `/workSchedule/dataOverviewRight`,
      data
    });
  }
  /**
   *  工作日程--日程视角--详情下载
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  downScheduleData(data) {
    return this.request({
      method: 'post',
      url: `/workSchedule/down_event_data`,
      responseType: 'blob',
      data
    });
  }
  /**
   *  工作日程--人员视角--详情下载
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  downPersonData(data) {
    return this.request({
      method: 'post',
      url: `/workSchedule/down_person_data`,
      responseType: 'blob',
      data
    });
  }
  /********************************
   * 工作日程-->通话列表
   ********************************/
  /**
   *  工作日程--头部筛选项获取下拉选项接口
   *
   * @author CaoJianBo
   * @param  {Object} params
   * @returns
   * @memberof LeadsService
   */
  pullDownWorkSchedule(params) {
    return this.request({
      method: 'get',
      url: `/workSchedule/pullDown`,
      params
    });
  }
  /**
   *  工作日程--通话列表--数据概览
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.startTime
   * @param  {integer} data.endTime
   * @returns
   * @memberof LeadsService
   */
  countNum(data) {
    return this.request({
      method: 'post',
      url: `/outCall/count`,
      data
    });
  }
  /**
   *  工作日程--通话列表--通话视角
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.startTime
   * @param  {integer} data.endTime
   * @returns
   * @memberof LeadsService
   */
  callTable(data) {
    return this.request({
      method: 'post',
      url: `/outCall/callTable`,
      data
    });
  }
  /**
   *  工作日程--通话列表--人员视角
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.startTime
   * @param  {integer} data.endTime
   * @returns
   * @memberof LeadsService
   */
  personTable(data) {
    return this.request({
      method: 'post',
      url: `/outCall/personTable`,
      data
    });
  }
  /**
   *  工作日程--通话列表--通话时长概览
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.startTime
   * @param  {integer} data.endTime
   * @returns
   * @memberof LeadsService
   */
  countForLong(data) {
    return this.request({
      method: 'post',
      url: `/outCall/countForLong`,
      data
    });
  }
  /**
   *  通话列表--通话视角--详情下载
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  downCallTable(data) {
    return this.request({
      method: 'post',
      url: `/outCall/downCallTable`,
      responseType: 'blob',
      data
    });
  }
  /**
   *  通话列表--人员视角--详情下载
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  downPersonTable(data) {
    return this.request({
      method: 'post',
      url: `/outCall/downPersonTable`,
      responseType: 'blob',
      data
    });
  }
  /**
   *  通话列表--通话明细--人员视角--查看详情
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.startTime
   * @returns
   * @memberof LeadsService
   */
  personTableDetail(data) {
    return this.request({
      method: 'post',
      url: `/outCall/personTableDetail`,
      data
    });
  }
  /********************************
   * 工作日程-->动态记录
   ********************************/
  /**
   *  工作日程 - 动态记录列表（按动态记录）
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.startTime
   * @returns
   * @memberof LeadsService
   */
  getRecordList(data) {
    return this.request({
      method: 'post',
      url: `/clue_record/schedule/record/list`,
      data
    });
  }
  /**
   *  工作日程 - 动态记录列表（按动态记录）
   *
   * @author CaoJianBo
   * @param  {Object} data
   * @param  {integer} data.startTime
   * @returns
   * @memberof LeadsService
   */
  getRecordUserList(data) {
    return this.request({
      method: 'post',
      url: `/clue_record/schedule/user/list`,
      data
    });
  }
  /**
   *  工作日程 - 动态记录列表-详情下载
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  downloadRecord(data) {
    return this.request({
      method: 'post',
      url: `/clue_record/schedule/record/download`,
      responseType: 'blob',
      data
    });
  }
  /**
   *  工作日程 - 动态记录-人员视角列表-详情下载
   *
   * @author caojianbo
   * @param  {Object} data
   * @returns
   * @memberof DataService
   */
  downloadUser(data) {
    return this.request({
      method: 'post',
      url: `/clue_record/schedule/user/download`,
      responseType: 'blob',
      data
    });
  }
}

export const calendarService = new CalendarService();
